import { MODULE_NAME } from '@/Modules/ReportsModule/PurchaseOrdersReport/shared/config/purchase-orders-reports-module.config';

export function getModuleName(): string {
  return MODULE_NAME;
}
